import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, message, Space } from 'antd';

import { useProfileImageRemove } from 'all-in-one-shared-api';
import { useKeycloak } from 'all-in-one-react-keycloak';
import { useAvatar } from 'api/useAvatar';
import { AvatarUpload } from 'pages/profile/components/ProfileAvatarUpload';
import { DependentData } from '../DependentsPage';
import generateKey from 'utils/generateKey';
import { Avatar } from 'components/avatar';

interface ManageDependentProps {
  dependentData: DependentData;
  isSpouse: boolean;
}

export const DependentAvatar = ({ dependentData }: ManageDependentProps): JSX.Element => {
  const { t } = useTranslation();
  const { keycloak } = useKeycloak();
  const [removeKey, setRemoveKey] = useState('');
  const { memberType } = dependentData;
  const { avatarUrl, mutate: mutateProfileImage } = useAvatar(memberType);

  useProfileImageRemove(
    removeKey,
    keycloak.token ?? '',
    {
      shouldRetryOnError: false,
      onSuccess: () => {
        message.success(t('profile.profilePicture.removeSuccess'));
        mutateProfileImage();
      },
      revalidateOnFocus: false,
    },
    dependentData.memberType,
  );

  const onRemoveProfileImage = () => {
    setRemoveKey(generateKey());
  };

  return (
    <Space direction="vertical">
      <Avatar size="large" avatarUrl={avatarUrl} />

      {/* Note(Andy Chow): Spouse should also be able to update the profile picture for the principal user, according to AIOBRB-1751 */}
      <Space direction="horizontal">
        <AvatarUpload
          child={<Button>{t('profile.changeAvatar')}</Button>}
          memberType={memberType}
          onUploadComplete={() => mutateProfileImage()}
        />
        <Button onClick={onRemoveProfileImage} disabled={!avatarUrl}>
          {t('profile.removeAvatar')}
        </Button>
      </Space>
    </Space>
  );
};
